import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "axios";

import en from "./locales/en/translation.json";
import vi from "./locales/vi/translation.json";

export const resources = {
  en: { translation: en },
  vi: { translation: vi },
};

i18n
  // Detect user language (?lang= → localStorage), default vi
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  .init({
    resources,
    // No `lng` here: it would bypass the detector (and ?lang=).
    fallbackLng: "vi",
    supportedLngs: ["en", "vi"],
    nonExplicitSupportedLngs: true, // en-US -> en
    interpolation: {
      // React already escapes values to prevent XSS
      escapeValue: false,
    },
    detection: {
      // ?lang=en|vi in the URL wins and is persisted to localStorage.
      // "navigator"/"htmlTag" are omitted so first-time visitors default to
      // Vietnamese (public/index.html has lang="en").
      order: ["querystring", "localStorage"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

// Send the active UI language with every API call so the server returns
// catalog / sub-catalog / product name + description in that language
// (falling back to the other language when a translation is missing).
axios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers["Accept-Language"] = i18n.resolvedLanguage || i18n.language || "vi";
  return config;
});

export default i18n;
